/*
Article Share
*/

class ArticleShare extends HTMLElement {
  constructor() {
    super();
    this.setupClickHandlers();
  }
  setupClickHandlers() {
    const rawUrl = window.location.href;
    const fmtUrl = rawUrl.endsWith("/") ? rawUrl.replace(/\/$/, "") : rawUrl;
    const copyText = this.querySelector(".share-button__copy span");
    const url = encodeURIComponent(fmtUrl);
    const title = encodeURIComponent(window.document.title);
    const launchNewWindow = (link) => {
      const top = window.innerHeight / 2;
      const left = window.innerWidth / 1.75;
      window.open(
        link,
        "",
        `menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=300,width=600,top=${top},left=${left}`
      );
    };
    document.addEventListener(
      "click",
      function (event) {
        const button = event.target.closest("button");
        if (button && button.matches(".share-button__facebook")) {
          const fbUrl = `https://www.facebook.com/sharer/sharer.php?u=${url}`;
          launchNewWindow(fbUrl);
        }
        if (button && button.matches(".share-button__copy")) {
          navigator.clipboard.writeText(rawUrl).then(() => {
            copyText.innerText = "Copied";
            setTimeout(() => {
              copyText.innerText = "Copy";
            }, 1500);
          });
        }
        if (button.matches(".share-button__twitter")) {
          const twUrl = `https://twitter.com/intent/tweet?url=${url}%2F&text=${title}`;
          launchNewWindow(twUrl);
        }
      },
      false
    );
  }
}

customElements.define("article-share", ArticleShare);

/*
Stack Images
*/

class StackImages extends HTMLElement {
  constructor() {
    super();
  }

  stackImages(container, element) {
    container.querySelectorAll(element).forEach((div) => {
      let containsOnlyImages = true;
      Array.from(div.childNodes).forEach((node) => {
        if (node.nodeType === Node.ELEMENT_NODE && node.tagName !== "IMG") {
          containsOnlyImages = false;
        }
      });

      if (containsOnlyImages) {
        div.style.display = "flex";
        div.style.gap = "10px";
        div.style.flexWrap = "wrap";
      }
    });
  }

  connectedCallback() {
    const rte = this.querySelector(".blog-rte");
    this.stackImages(rte, "div");
    this.stackImages(rte, "p");
  }
}
customElements.define("stack-images", StackImages);
